import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { getDeviceHistoryByWorkspaceAndWorkspaceToWorkspace } from '../thunks/deviceHistory';
import { addSituation } from './situations';
import { getCurrentUser } from '../thunks/user';

const deviceHistoriesAdapter = createEntityAdapter();

const deviceHistoriesSlice = createSlice({
  name: 'deviceHistories',
  initialState: deviceHistoriesAdapter.getInitialState({}),
  reducers: {
    addDeviceHistory: (state, action) => {
      const { deviceHistory } = action.payload;
      deviceHistoriesAdapter.upsertOne(state, deviceHistory);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        getDeviceHistoryByWorkspaceAndWorkspaceToWorkspace.fulfilled,
        (state, action) => {
          deviceHistoriesAdapter.upsertMany(state, action.payload);
          state.fetchedTraffic = true;
        }
      )
      // TODO cambiar esto cuando se defina el comportamiento de workspace to workspace
      .addCase(getCurrentUser.fulfilled, (state) => {
        deviceHistoriesAdapter.removeAll(state);
      });
  },
});

export const { removeDeviceHistory, addDeviceHistory } =
  deviceHistoriesSlice.actions;

export const deviceHistoriesAdapterSelectors =
  deviceHistoriesAdapter.getSelectors((state) => state.deviceHistories);

export default deviceHistoriesSlice.reducer;
